// extracted by mini-css-extract-plugin
export default {"actionsDot":"Popovers_actionsDot__Fd-5v","disabled":"Popovers_disabled__0Lccl","disabledIcon":"Popovers_disabledIcon__mYhjy"};